import http from '../../../services/api'
import type { APIResponse } from '../../../services/types'
import type { ItemUnitPriceApi, ItemUnitSellingLookupApi } from '../types'

const apiPath = import.meta.env.VITE_API_PATH

function itemUnitPricesPath(itemUuid: string): string {
  return `${apiPath}items/${itemUuid}/unit-prices`
}

async function getItemUnitPrices(itemUuid: string) {
  return await http.get<APIResponse<ItemUnitPriceApi[]>>(itemUnitPricesPath(itemUuid))
}

async function createItemUnitPrice(itemUuid: string, unitUuid: string, sellingPrice: string | number) {
  return await http.post<APIResponse<ItemUnitPriceApi>>(itemUnitPricesPath(itemUuid), {
    unit_uuid: unitUuid,
    selling_price: sellingPrice,
  })
}

async function updateItemUnitPrice(itemUuid: string, priceUuid: string, sellingPrice: string | number) {
  return await http.put<APIResponse<ItemUnitPriceApi>>(`${itemUnitPricesPath(itemUuid)}/${priceUuid}`, {
    selling_price: sellingPrice,
  })
}

/** Resolve selling price and available quantity for a selected item unit (backend conversion). */
async function lookupItemUnitSelling(itemUuid: string, unitUuid: string) {
  const params = new URLSearchParams({ unit_uuid: unitUuid })
  return await http.get<APIResponse<ItemUnitSellingLookupApi>>(
    `${itemUnitPricesPath(itemUuid)}/lookup?${params.toString()}`,
    { errorHandle: false } as any,
  )
}

const itemUnitPricesService = {
  getItemUnitPrices,
  createItemUnitPrice,
  updateItemUnitPrice,
  lookupItemUnitSelling,
}

export default itemUnitPricesService
